module.exports = __webpack_public_path__ + "static/media/import_product.f00f71b7.png";